import React from 'react'

const addDefaultSrc = (e) => {
    e.target.src = '/assets/images/noimage.png'
}

const AvatarImage = ({
    onClick,
    data,
    className,
    folder,
    avatar,
    avatar_type,
    width,
    height,
    custom,
}) => {
    return (
        <>
            {parseInt(data[avatar_type || 'avatar_type'], 10) === 2 ? (
                <>
                    <img
                        onClick={onClick || null}
                        // src={data[avatar || 'avatar']}
                        src={
                            custom
                                ? avatar
                                    ? data[avatar]?.replace('www.', 'staging.')
                                    : data?.avatar?.replace('www.', 'staging.')
                                : data[avatar || 'avatar']
                        }
                        alt={data.title}
                        onError={addDefaultSrc}
                        width={width}
                        height={height}
                        className={className || ''}
                    />
                </>
            ) : (
                <img
                    onClick={onClick || null}
                    src={`${global.site_url}/uploads/${folder || 'product'}/${
                        data[avatar || 'avatar']
                    }`}
                    alt={data.title}
                    onError={addDefaultSrc}
                    width={width}
                    height={height}
                    className={className || ''}
                />
            )}
        </>
    )
}

export default AvatarImage
